import { Link } from '@tanstack/react-router';
import { Layers, BookOpen, FileText, ClipboardCheck, ChevronRight } from 'lucide-react';

import type { ProfileSummaryLearningSnapshot } from '@/lib/api/profileSummary';

interface Props {
  snapshot: ProfileSummaryLearningSnapshot;
  batchId: string;
}

export function LearningSnapshotCard({ snapshot, batchId }: Props) {
  const rows = [
    {
      key: 'modules',
      icon: Layers,
      label: 'Modules Completed',
      counts: snapshot.modules,
      to: '/courses/$batchId' as const,
    },
    {
      key: 'topics',
      icon: BookOpen,
      label: 'Topics Completed',
      counts: snapshot.topics,
      to: '/courses/$batchId' as const,
    },
    {
      key: 'assignments',
      icon: FileText,
      label: 'Assignments Submitted',
      counts: snapshot.assignments,
      to: '/courses/$batchId' as const,
    },
    {
      key: 'assessments',
      icon: ClipboardCheck,
      label: 'Assessments Completed',
      counts: snapshot.assessments,
      to: '/courses/$batchId' as const,
    },
  ];

  return (
    <section className="rounded-xl border border-[#e8e4df] bg-white p-6" aria-label="Learning snapshot">
      <h2 className="font-heading text-base font-bold text-[#1a1714]">Learning Snapshot</h2>
      <div className="mt-4 divide-y divide-[#f2f0ed]">
        {rows.map(({ key, icon: Icon, label, counts, to }) => (
          <Link
            key={key}
            to={to}
            params={{ batchId }}
            className="flex items-center gap-3 py-3 transition-colors hover:bg-[#faf9f7]"
          >
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#f2f0ed]">
              <Icon className="h-4 w-4 text-[#6b6459]" />
            </span>
            <span className="flex-1 text-sm font-medium text-[#1a1714]">{label}</span>
            <span className="text-sm text-[#9a9589]">
              {counts.completed} / {counts.total}
            </span>
            <ChevronRight className="h-4 w-4 text-[#c4c0b8]" />
          </Link>
        ))}
      </div>
    </section>
  );
}
